export const ModifyWarning = () => (
  <span className='has-text-danger m-5'>
    You can not modify this page!
  </span>
)